import { getBrowserTimeZone, getHourInTimeZone } from './getSalutation.utils';

/**
 * Get a time-of-day greeting based on the user's timezone
 *
 * Uses the browser's timezone by default (best practice for client-side apps).
 * Returns just the greeting phrase for flexible composition with names/punctuation.
 *
 * Hour ranges:
 * - Morning: 5:00 - 11:59
 * - Afternoon: 12:00 - 17:59
 * - Evening: 18:00 - 4:59
 *
 * @param timeZone - Optional IANA timezone (defaults to browser timezone)
 * @returns Greeting string like "Good morning"
 *
 * @example
 * // Flexible composition
 * `${getSalutation()}, ${firstName}!`        // "Good morning, John!"
 * `${getSalutation()} ${firstName}!<br/>`    // With line break after
 * getSalutation()                             // Just "Good afternoon"
 */
export function getSalutation(timeZone?: string): string {
  const tz = timeZone ?? getBrowserTimeZone();
  const hour = getHourInTimeZone(new Date(), tz);

  if (hour >= 5 && hour < 12) {
    return 'Good morning';
  }
  if (hour >= 12 && hour < 18) {
    return 'Good afternoon';
  }
  return 'Good evening';
}
